import React, { useEffect, useRef, useState } from "react";
import AuthServices from "../../api/AuthServices";
import { useTranslation } from "react-i18next";
import { LanguageIcon } from "../../icons";
import clsx from "clsx";
import { useMedia } from "../../hook/useMedia";

const LANGUAGE = {
  "en-US": "en",
  en: "en",
  es: "es",
};

export const LanguageSelector = ({ variant = "default" }) => {
  const containerRef = useRef(null);
  const { i18n, t } = useTranslation();
  const { isAfterTablet } = useMedia();
  const isLight = variant === "light";
  const isCompact = isLight && isAfterTablet;

  const [currentLanguage, setCurrentLanguage] = useState({
    id: 1,
    name: "English",
    code: "en",
  });
  const [languageList, setLanguageList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    AuthServices.getLanguages().then((res) => {
      setLanguageList([...res?.data]);
      const lang =
        res?.data?.length &&
        res?.data?.find((el) => el?.code === LANGUAGE[i18n.language]);
      setCurrentLanguage(lang);
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleChange = async (data) => {
    i18n.changeLanguage(data.code);
    setCurrentLanguage(data);
    setIsOpen(false);
    const params = {
      language: LANGUAGE[data.code],
    };
    await AuthServices.changeLanguage(params);
  };

  return (
    <div
      ref={containerRef}
      className={clsx(
        "pos-relative language-selector",
        isLight && "language-selector--light"
      )}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={() => setIsOpen((prev) => !prev)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            setIsOpen((prev) => !prev);
          }
        }}
        className={clsx(
          "language-selector__trigger border flex border-radius-6 cursor-pointer align-items-center",
          isCompact ? "fs-12 pa-2" : "fs-16",
          !isCompact && (isAfterTablet ? "pa-2" : "pa-6"),
          isLight ? "color-white" : "border-dark"
        )}
        style={isLight ? { borderColor: "#ffffff" } : undefined}
      >
        <LanguageIcon
          height={isCompact ? 14 : 16}
          width={isCompact ? 14 : 16}
          className={isCompact ? "pr-0" : "pr-1"}
          style={isLight ? { filter: "brightness(0) invert(1)" } : undefined}
        />
        {!isCompact && t("NUTRITION_COMMON_LBL_LANGUAGE_SELECTOR")}
        <span
          className={clsx(
            "pl-1 font-weight-bold",
            isLight ? "color-white" : "color-dark"
          )}
        >
          {isCompact
            ? currentLanguage?.code?.toUpperCase()
            : currentLanguage?.name}
        </span>
      </div>
      {isOpen && (
        <div
          className={clsx(
            "language-selector__menu pos-absolute mt-1 ptb-2 plr-2 border-radius-4 border-dark border",
            isCompact ? "fs-12" : "fs-16"
          )}
        >
          {languageList.length > 0 &&
            languageList.map((el) => (
              <div
                key={el.id ?? el.code}
                className="cursor-pointer languagePopup"
                onClick={() => handleChange(el)}
              >
                {el.name}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};
